<template>
  <div>
    <v-toolbar-title>
      <span style="font-weight: 700; margin-bottom: 50px; text-align: center; color : #26384B">
        <p>
          {{ $t('forms.modal.messageApiKey') }}
        </p>

      </span>
    </v-toolbar-title>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding apiKey"
        cols="12"
      >
        <span>
          {{ apiKey }}
          <v-btn
            icon
            small
            class="ml-2"
            @click="copyLink"
          >
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>


export default {
    props: {
        apiKey: {
            type: String,
            required: true,
        },
    },
    methods: {
        copyLink() {
            navigator.clipboard.writeText(this.apiKey);
        },
    },
};
</script>
<style scoped lang="scss">
.apiKey {
  text-align: center;
  margin-top: 20px;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
  span {
    border: 2px solid #959DA6;
    padding: 15px;
    border-radius: 5px;
    color: #26384b;
    background-color: #F5F5F5;
  }
}
</style>
